<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
            <vue-headful :title="'Safety Meeting on '+ this.$options.filters.moment(meeting.meeting_date, 'MM/DD/YYYY') + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/safety-meetings`">
                            <i class="fa fa-life-ring"></i> Safety Meetings
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/safety-meetings/view/${meeting.safety_meeting_id}`">
                            Meeting on {{ meeting.meeting_date | moment("MM/DD/YYYY") }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        Send Text Blast
                    </li>
                </ol>
            </h4>

            <div v-if="textSuspended" class="alert alert-danger">
                MeritEHS Texting has been temporarily suspended due to regulatory compliance changes (A2P 10DL) by US Carriers. While we await the approval of our sending application, our texting feature must be paused as these Carriers will reject texts without compliance approval.<br/><br/>

                We at the Merit Team are doing everything we can to expedite this approval, and we will provide email updates when available.
            </div>

            <div class="row mb-3">
                <div class="col-lg-4 mb-lg-0 mb-2">
                    <div class="card">
                        <div class="card-header">
                            <strong>Safety Meeting</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col text-muted">Meeting Date</div>
                                <div class="col-lg-7">{{ meeting.meeting_date | moment("MM/DD/YYYY") }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Meeting Title</div>
                                <div class="col-lg-7">{{ meeting.meeting_title }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 mb-lg-0 mb-2">
                    <div class="card">
                        <div class="card-header">
                            <strong>Sending Limits</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col text-muted">Remaining Text Credits:</div>
                                <div class="col-lg-3">{{ monthly_text_limit }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Total Texts Sent MTD:</div>
                                <div class="col-lg-3">{{ total_texts_sent_mtd }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Total Texts Sent All Time:</div>
                                <div class="col-lg-3">{{ total_texts_sent_all }}</div>
                            </div>
                            <router-link to="/billing">Purchase Text Credits</router-link>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 mb-lg-0 mb-2">
                    <div class="card">
                        <div class="card-header">
                            <strong>Confirm Text Blast</strong>
                        </div>
                        <div class="card-body">
                            <p>You are about to text {{ this.totalSelected }} employees.</p>

                            <template v-if="textSuspended !== true">
                                <button class="btn btn-sm btn-warning" v-on:click="sendTextBlast()" :disabled="this.totalSelected === 0 || sending">Send Text Blast</button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <div class="alert alert-warning">
                All Text messages will come from the number: <strong>{{ textNumber }}</strong>. You and your employees can save this number as a contact in your phone.
            </div>

            <div class="card mb-3">
                <div class="card-header">
                    <strong>Select Recipients from Employee List ({{ totalSelected }})</strong>
                </div>
                <div class="card-body">
                    <div class="alert alert-info mb-2">
                        The employee list is automatically filtered on <strong>Active</strong> Employees <strong>with a Phone Number</strong> on record. Additional filters can be applied using the <i class="fa fa-filter"></i> button below.
                    </div>

                    <div class="alert alert-danger mb-2" v-if="errors.safety_meeting_id">
                        {{ errors.safety_meeting_id }} Visit your <router-link to="/billing">Billing Settings</router-link> to purchase more credits
                    </div>

                    <v-server-table name="employeeTextBlastTbl" ref="employeeTextBlastTbl" :url="`/employees/list?assetType=SafetyMeeting&method=text`" :columns="columns" :options="options">

                        <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                            <div class="clearfix d-md-none d-block"></div>

                            <table-filters-2 ref="meetingTextTableFilters" filterUrl="/employees/filters" v-bind:filters="filters" :emptyFilters="filterDefs" :filterKey="filterKey" @filtersChanged="refreshTableData" @filtersCleared="filtersCleared">
                                <template slot-scope="slotProps">
                                    <div class="d-inline-block" v-if="slotProps.filterData.subcontractors != null && slotProps.filterData.subcontractors.length > 0">
                                        <b-form-select v-model="slotProps.filters['employee.subcontractor_id']" size="sm" :options="slotProps.filterData.subcontractors"></b-form-select>
                                    </div>
                                    <div class="d-inline-block">
                                        <multi-select v-model="slotProps.filters['employee.division_id']" :btnLabel="(values) => ('Divisions ('+values.length+')')" :selectOptions="slotProps.filterData.divisions" :options="{multi: true}"></multi-select>
                                    </div>
                                    <div class="d-inline-block">
                                        <multi-select v-model="slotProps.filters['employee.position']" :btnLabel="(values) => ('Positions ('+values.length+')')"
                                        :selectOptions="slotProps.filterData.positions" :options="{multi: true}"></multi-select>
                                    </div>
                                </template>
                            </table-filters-2>

                        </div>

                        <template slot="h__EmployeeId">
                            <b-form-checkbox v-model="select_all" :value="true" :unchecked-value="false" @click="selectAll()" plain>Select All</b-form-checkbox>
                        </template>

                        <template slot="EmployeeId" slot-scope="props">
                            <template v-if="props.row.opted_out_of_texts === 1">
                                <label class="badge badge-danger" title="Employee has opted out of receiving texts. Contact support to reinitiate the Opt-in process">Text Disabled</label>
                            </template>
                            <template v-else-if="props.row.enable_text_blasts !== 1">
                                <label class="badge badge-warning" title="Texting is disabled on the Employee Profile. Edit the Profile to enable texting">Text Disabled</label>
                            </template>
                            <template v-else>
                                <input type="checkbox" :name="`cbx_all_${props.row.EmployeeId}`" value="true" :checked="select_all ? 'checked' : ''" v-if="select_all" disabled="disabled" />
                                <b-form-checkbox v-model="employeeIds" :value="props.row.EmployeeId" plain :disabled="select_all" v-else />
                            </template>
                        </template>

                        <router-link slot="LastName" slot-scope="props" :to="`/employees/view/${props.row.EmployeeId}`" title="View Employee">
                            {{ props.row.FirstName }} {{ props.row.LastName }}
                        </router-link>

                        <template slot="read_at" slot-scope="props">
                            <span v-if="props.row.read_at">{{ props.row.read_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                        </template>

                        <template slot="completed_at" slot-scope="props">
                            <span v-if="props.row.completed_at">{{ props.row.completed_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                        </template>

                    </v-server-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';

    export default {
        data: function() {
            return {
                loading: true,
                sending: false,
                userTimezone: this.$store.state.user.timezone,
                safety_meeting_id: this.$route.params.id,
                meeting: {},
                select_all: false,
                employeeIds: [],
                employeeData: [],
                totalFiltered: null,
                errors: {},
                monthly_text_limit: null,
                total_texts_sent_mtd: null,
                total_texts_sent_all: null,

                columns: ['EmployeeId', 'LastName', 'position', 'EmployeeNumber', 'Phone', 'DivisionName', 'subcontractor_name'],
                options: {
                    sortable: ['LastName', 'position', 'EmployeeNumber', 'Phone', 'DivisionName', 'subcontractor_name'],
                    headings: {
                        LastName: 'Name',
                        position: 'Position',
                        EmployeeNumber: 'Employee Number',
                        phone: 'Phone',
                        DivisionName: 'Division',
                        subcontractor_name: 'Subcontractor',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'employee.LastName',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.totalFiltered = response.data.count;
                        this.employeeData = response.data.data;

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = filterExtractor.extractFilters(this.filters);

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },

                filterKey: 'meetingTextFilters',

                filterDefs: {
                    'employee.is_approved_driver': null,
                    'employee.subcontractor_id': null,
                    'employee.division_id': [],
                    'employee.position': [],
                }
            }
        },

        watch: {
            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {
            totalSelected(){
                //Check employees
                if(this.select_all)
                {
                    return this.totalFiltered;
                }

                //Return the Employees count
                return this.employeeIds.length;
            },

            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },

            textNumber(){
                //Setup
                var phone = this.$root.meritehs_number.replace('+1', '');

                //Clean it
                var formatted = '+1 ' + phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

                //SEnd it
                return formatted;
            },

            textSuspended(){
                //Send it
                return this.$root.text_suspended === true || this.$root.text_suspended === 'true' ? true : false;
            }
        },

        methods: {

            getSafetyMeeting() {
                //Get the data
                this.$http
                    .get('/safety-meetings/text/' + this.safety_meeting_id)
                    .then(response => {
                        //Set all the data
                        this.meeting = response.data.meeting;
                        this.monthly_text_limit = response.data.monthly_text_limit;
                        this.total_texts_sent_mtd = response.data.total_texts_sent_mtd;
                        this.total_texts_sent_all = response.data.total_texts_sent_all;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            sendTextBlast() {
                //Sending
                this.sending = true;

                //Reset the Errors
                this.errors = {};

                //Get the data
                this.$http
                    .post('/safety-meetings/text/' + this.safety_meeting_id, {select_all: this.select_all, filters: filterExtractor.extractFilters(this.filters), employees: this.employeeIds})
                    .then(response => {
                        //Send to the View
                        this.$router.push('/safety-meetings/view/' + this.safety_meeting_id);
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.sending = false;
                    });
            },

            selectAll(){
                //Set it
                this.select_all = !this.select_all;

                //Check for false
                if(!this.select_all)
                {
                    //Reset
                    this.employeeIds = [];

                    //Stop Here
                    return;
                }

                //Add All
                for (var i = this.employeeData.length - 1; i >= 0; i--)
                {
                    //Push it
                    this.employeeIds.push(this.employeeData[i].EmployeeId);
                }
            },

            refreshTableData(filters) {
                //Set the data
                this.$refs.employeeTextBlastTbl.setPage(1);
                this.$refs.employeeTextBlastTbl.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.meetingTextTableFilters.resetColVis(this.$refs.employeeTextBlastTbl);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.meetingTextSavedFilters.setFilterParams(this.$refs.employeeTextBlastTbl);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.meetingTextTableFilters.setColVis(this.$refs.employeeTextBlastTbl);
            },
        },
        mounted() {
            //Get the Safety Meeting
            this.getSafetyMeeting();
        }
    }
</script>
